import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useFlyerDownloadModalContext } from 'src/app/pages/starterDashboardV2/shared/components';
import { useSharingModal } from 'src/app/pages/starterDashboardV2/shared/contexts';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import {
	type UseSharingToolsReturn as BaseUseSharingToolsReturn,
	useSharingTools as useBaseSharingTools,
} from './index';

type SharingToolsActions = {
	navigateToAllTools: () => void;
	navigateToGroupRecommendations: () => void;
	navigateToReadyToSharePosts: () => void;
	navigateToShareVisual: () => void;
	openFlyerDownloadModal: () => void;
	openRTSFacebookSharingModal: () => void;
	openRTSInstagramSharingModal: () => void;
};

type UseSharingToolsReturn = Omit<BaseUseSharingToolsReturn, 'actions'> & { actions: SharingToolsActions };

const RTS_TRACKING_PROPS = {
	context: 'petition_dashboard_grow_petition_v2',
	viewContext: 'home',
} as const;

export function useSharingTools(): UseSharingToolsReturn {
	const { data, actions } = useBaseSharingTools();
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const { openModal: openFlyerDownloadModal } = useFlyerDownloadModalContext();
	const { startSharingFlow } = useSharingModal();
	const isMobile = useIsMobile();
	return {
		data,
		actions: {
			...actions,
			openFlyerDownloadModal: () => {
				openFlyerDownloadModal('starter_dashboard_sharing_tools');
			},
			openRTSFacebookSharingModal: () => {
				startSharingFlow({
					platform: 'facebook',
					postType: 'post',
					petition,
					defaultOpen: false,
					trackingProps: RTS_TRACKING_PROPS,
				});
			},
			openRTSInstagramSharingModal: () => {
				if (isMobile) {
					startSharingFlow({
						platform: 'instagram',
						postType: 'story',
						petition,
						defaultOpen: false,
						trackingProps: RTS_TRACKING_PROPS,
					});
				} else {
					actions.navigateToReadyToSharePosts();
				}
			},
		},
	};
}
